<div class="modal-content">
  <form
    #cameraForm="ngForm"
    (ngSubmit)="isReady && cameraForm.form.valid && saveCamera()"
  >
    <div class="modal-header bg-info text-white">
      <h4>Camera Editor</h4>
    </div>
    <div class="modal-body">
      <div class="row row-cols-1 row-cols-lg-3">
        <div class="col mb-3">
          <label for="txtName">Name</label
          ><input
            #txtName="ngModel"
            [(ngModel)]="cameraModel.Name"
            type="text"
            name="txtName"
            id="txtName"
            class="form-control"
            required
            minlength="3"
          />
          @if (
            ((txtName.dirty && txtName.touched) || cameraForm.submitted) &&
            txtName.errors?.required
          ) {
            <small class="text-danger">Name is required</small>
          }
          @if (
            ((txtName.dirty && txtName.touched) || cameraForm.submitted) &&
            !txtName.errors?.required &&
            txtName.errors?.minlength
          ) {
            <small class="text-danger"
              >Name must be at least 3 characters long</small
            >
          }
        </div>
        <div class="col mb-3">
          <label for="txtIPAddress">IP Address</label
          ><input
            #txtIPAddress="ngModel"
            [(ngModel)]="cameraModel.IpAddress"
            placeholder="0.0.0.0"
            type="text"
            name="txtIPAddress"
            id="txtIPAddress"
            class="form-control"
            required
            pattern="^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$"
          />
          @if (
            ((txtIPAddress.dirty && txtIPAddress.touched) ||
              cameraForm.submitted) &&
            txtIPAddress.errors?.required
          ) {
            <small class="text-danger">IP Address is required</small>
          }
          @if (
            ((txtIPAddress.dirty && txtIPAddress.touched) ||
              cameraForm.submitted) &&
            !txtIPAddress.errors?.required &&
            txtIPAddress.errors?.pattern
          ) {
            <small class="text-danger">Invalid IP Address</small>
          }
        </div>
        <div class="col mb-3">
          <label for="txtRes">Resolution</label>
          <input
            #txtRes="ngModel"
            [(ngModel)]="cameraModel.Resolution"
            placeholder="width x height"
            type="text"
            name="txtRes"
            id="txtRes"
            class="form-control"
            required
            pattern="^[0-9]{1,4}[x,X][0-9]{1,4}$"
          />
          @if (
            ((txtRes.dirty && txtRes.touched) || cameraForm.submitted) &&
            txtRes.errors?.required
          ) {
            <small class="text-danger">Enter a Resolution</small>
          }
          @if (
            ((txtRes.dirty && txtRes.touched) || cameraForm.submitted) &&
            !txtRes.errors?.required &&
            txtRes.errors?.pattern
          ) {
            <small class="text-danger"
              >Invalid Resolution (width<strong>x</strong>height)</small
            >
          }
        </div>
      </div>
      <div class="row row-cols-1 row-cols-lg-3">
        <div class="col mb-3">
          <label for="txtServiceDate">Service Date</label>
          <div class="input-group">
            <input
              ngbDatepicker
              #dp="ngbDatepicker"
              #txtServiceDate="ngModel"
              [(ngModel)]="cameraModel.ServiceDate"
              id="txtServiceDate"
              name="txtServiceDate"
              type="text"
              class="form-control"
            />
            <button (click)="dp.toggle()" type="button" class="btn btn-info">
              <fa-icon [icon]="icons.calendar"></fa-icon>
            </button>
          </div>
        </div>
        <div class="col mb-3">
          <label for="txtView">View ID</label>
          <input
            #txtView="ngModel"
            [(ngModel)]="cameraModel.ViewId"
            type="text"
            name="txtView"
            id="txtView"
            class="form-control"
            required
            pattern="^[1-9]+$"
          />
          @if (
            ((txtView.dirty && txtView.touched) || cameraForm.submitted) &&
            txtView.errors?.required
          ) {
            <small class="text-danger">Enter Camera View (default is 1)</small>
          }
          @if (
            ((txtView.dirty && txtView.touched) || cameraForm.submitted) &&
            !txtView.errors?.required &&
            txtView.errors?.pattern
          ) {
            <small class="text-danger">Invalid View ID (numbers only)</small>
          }
        </div>
        <div class="col mb-3">
          <label for="cboType">Camera Type</label
          ><select
            [(ngModel)]="cameraModel.CameraType"
            #cboType="ngModel"
            name="cboType"
            id="cboType"
            class="form-control"
            required
          >
            <option [ngValue]="0">Normal</option>
            <option [ngValue]="1">Panoramic</option>
            <option [ngValue]="2">Thermal</option>
          </select>
          @if (
            ((cboType.dirty && cboType.touched) || cameraForm.submitted) &&
            cboType.errors?.required
          ) {
            <small class="text-danger">Select a Camera Type</small>
          }
        </div>
      </div>
      <div class="row row-cols-1 row-cols-lg-12">
        <div class="col-4 mb-3">
          <label for="txtSerial">Serial Number (MAC)</label>
          <div class="input-group">
            <input
              #txtSerial="ngModel"
              [ngModel]="cameraModel.MacAddress"
              name="txtSerial"
              id="txtSerial"
              type="text"
              class="form-control"
              readonly
            />
            <div
              class="input-group-text"
              role="button"
              (click)="copyMacAddress()"
            >
              <fa-icon [icon]="macAddressCopyIcon"></fa-icon>
            </div>
          </div>
        </div>
        <div class="col-8 mb-3">
          <label for="txtAcsId">ACS Id</label>
          <div class="input-group">
            <input
              #txtAcsId="ngModel"
              [ngModel]="cameraModel.AcsId"
              name="txtAcsId"
              id="txtAcsId"
              type="text"
              class="form-control"
              readonly
            />
            <div class="input-group-text" role="button" (click)="copyAcsId()">
              <fa-icon [icon]="acsIdCopyIcon"></fa-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer text-end">
      <button
        type="button"
        (click)="deleteCamera()"
        [disabled]="!isReady"
        class="btn btn-outline-danger btn-sm"
      >
        Delete
      </button>
      <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary btn-sm"
        [disabled]="!isReady"
      >
        Save
      </button>
    </div>
  </form>
</div>
